import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
const easeOut = [0.23, 1, 0.32, 1] as const;
const heroHighlights = ['7 Complete Volumes', '150 Ready-to-Teach Sessions', '5 Professional Bonuses', 'Immediate Access'];
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden bg-navy" data-id="element-99" data-mp="128pixfs3x15m">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-100" data-mp="xbpbp1jitscx">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: easeOut
      }} className="w-full" data-id="element-101" data-mp="sai1kvtwoh33">
          <div className="inline-block px-3 py-1 rounded-full border border-gold/60 bg-white/5 text-gold-light font-medium text-[10px] sm:text-sm tracking-wide whitespace-nowrap mb-4 sm:mb-6" data-id="element-102" data-mp="3d1sa6w93nhsl">
            🥋 TAEKWONDO INSTRUCTOR READY
          </div>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-4 sm:mb-6 text-white" data-id="element-103" data-mp="3j6ocnm8x2qr5">
            Solve an entire year of Taekwondo classes in just{' '}
            <span className="text-gold" data-id="element-104" data-mp="39cpc2rohrf1b">5 MINUTES</span>
          </h1>

          <p className="text-sm sm:text-base md:text-lg text-white/80 max-w-3xl mx-auto mb-4 sm:mb-6" data-id="element-105" data-mp="3e7uydrlt2vpx">
            Taekwondo Instructor Ready —{' '}
            <span className="text-gold font-semibold" data-id="element-106" data-mp="358hncui19z33">150 ready-to-teach</span> Taekwondo sessions,
            7 complete volumes and{' '}
            <span className="text-gold font-semibold" data-id="element-107" data-mp="2ql692kugw0za">5 professional bonus guides</span>
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: easeOut
      }} className="relative w-full max-w-[320px] sm:max-w-lg md:max-w-3xl mb-4 sm:mb-6" data-id="element-108" data-mp="2vj7wfhyxemgk">
          <img src={HERO_IMAGE} alt="Taekwondo Instructor Ready complete system: 7 volumes, 150 ready-to-coach sessions and 5 bonus guides" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-109" data-mp="s3mc1z88nsws" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: easeOut
      }} className="w-full" data-id="element-110" data-mp="ddnfg0wc0pjf">
          <p className="text-sm sm:text-lg md:text-xl text-white/85 leading-snug max-w-2xl mx-auto mb-5 sm:mb-7" data-id="element-111" data-mp="161j7utevbvae">
            150 ready-to-teach Taekwondo sessions designed to help instructors plan less, teach with
            more structure and develop students from beginner to advanced.
          </p>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-112" data-mp="3lu02z1erz4zq">
            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10" data-id="element-113" data-mp="3hrdbj1m0nm32">
              🟡 GET THE COMPLETE TAEKWONDO COACHING SYSTEM NOW
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-white/70" data-id="element-114" data-mp="269zi3saawvnv">
            {heroHighlights.map(highlight => <div key={highlight} className="flex items-center gap-1.5" data-id="element-115" data-mp="2b2aiew8yejgy">
                <CheckCircle size={14} className="text-emerald-brand" data-id="element-116" data-mp="2g0luldmq162c" />
                <span data-id="element-117" data-mp="2kyn9dmd46j80">{highlight}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}